import api from '../../../services/api'
import {
  GeneralResponse,
  postProfessionalProfileImageRequest,
  putProfessionalProfileRequest
} from './profile-service.interfaces'
import { storageUserSave } from '../../../storage/storageUser'

const getProfessionalProfile = async (): Promise<GeneralResponse> => {
  const response = await api.get('/professionals/me')
  storageUserSave(response.data)
  return {
    status: response?.status,
    data: response?.data
  }
}

const putProfessionalProfile = async ({ payload }: putProfessionalProfileRequest): Promise<GeneralResponse> => {
  const response = await api.put('/professionals/me', payload)
  storageUserSave(response.data)
  return {
    status: response?.status,
    data: response?.data
  }
}

const postProfessionalProfileImage = async ({ payload }: postProfessionalProfileImageRequest): Promise<GeneralResponse> => {
  const response = await api.post('/professionals/profileImage', payload)
  return {
    status: response?.status,
    data: response?.data
  }
}

export const ProfileService = {
  getProfessionalProfile,
  putProfessionalProfile,
  postProfessionalProfileImage
}
